/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ActionType = "AA" | "AACK" | "AAD" | "ABF" | "AC" | "ACCL" | "ACH" | "ACR" | "ACRO" | "ADIE" | "AEC" | "AEIE" | "AFDA" | "AFDR" | "AFDU" | "AFNC" | "AFNU" | "AIAD" | "AIAE" | "AIAN" | "AIAR" | "AIAS" | "AIAT" | "AIRR" | "AIRS" | "AIRT" | "AM" | "ANC" | "AR" | "ARE" | "AS" | "ATCH" | "AU" | "BAAD" | "BACR" | "BADI" | "BAIG" | "BAPE" | "BAPI" | "BAPR" | "BAUI" | "BAUP" | "BAVE" | "BCC" | "BCU" | "BTIG" | "BTUI" | "CAREMFT" | "CASC" | "CASETFT" | "CASU" | "CIC" | "CISC" | "CISS" | "CISU" | "CIT" | "CIU" | "CIX" | "CTAPR" | "CTBLK" | "CTCAA" | "CTCAN" | "CTREC" | "CTREQ" | "CTUBL" | "CTVFY" | "EEU" | "FIFSI" | "FIFSP" | "FOTU" | "FSFSI" | "FSFSP" | "GCBFV" | "GCBRA" | "GCBRC" | "GCBRD" | "GCBRF" | "GCBRI" | "GCBRO" | "GCBRV" | "GCMAC" | "GCMBD" | "GCMCA" | "GCMCD" | "GCMCR" | "GCMEX" | "GCMFL" | "GCMGA" | "GCMRE" | "GCMRI" | "GCMRR" | "GCMRS" | "GCMSA" | "GCMSU" | "GCMTR" | "GCPCO" | "GCPCR" | "GCPFL" | "GCPPO" | "GCPSU" | "GCSAM" | "GCSCA" | "GCSCR" | "GCSDA" | "GCSFD" | "GCSFI" | "GCSPA" | "GCSPC" | "GCSPD" | "GCSPR" | "GCSRE" | "GCSSP" | "GCSSR" | "LLEDN" | "MACC" | "MATC" | "MATU" | "MLBAI" | "MLBAU" | "MLTC" | "MLTU" | "OAA" | "OAR" | "OC" | "OCC" | "OCD" | "OM" | "OMCLA" | "OMCLD" | "OMCLN" | "OMCLR" | "OMCNI" | "OMD" | "OMEXP" | "OMOVA" | "OMOVD" | "OMPR" | "OMQA" | "OMRBC" | "OP" | "OPCA" | "OPFC" | "OQ" | "OR" | "ORRCE" | "OTC" | "OX" | "RLWHCH" | "SC" | "SCR" | "SF" | "SR" | "SRA" | "SRF" | "SS" | "SU" | "TBF" | "TCH" | "TCR" | "TFDA" | "TFDR" | "TFDU" | "TIGC" | "TIGD" | "TIGU" | "TISC" | "TISU" | "TPC" | "TPU" | "TRSC" | "TRSU" | "ULMVF" | "ULMVS" | "ULNS" | "ULSC" | "ULUV" | "UMA" | "UMAF" | "UMAP" | "UMAR" | "UMARP" | "UMCP" | "UMCR" | "UMD" | "UMRRC" | "UMUD" | "UMURP" | "UUE" | "UUF" | "UUL" | "UUP" | "UUSA" | "UUSD" | "UUU" | "UVE" | "VSPA" | "VSPR" | "VSPU" | "WHCH" | "ZBTR" | "ZBTU" | "ZIR" | "ZITR" | "ZIU" | "ZPC" | "ZTP" | "ZTR" | "ZUC" | "ZUU" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ApprovalActionLogDataTable_actionLogs$ref: FragmentReference;
declare export opaque type ApprovalActionLogDataTable_actionLogs$fragmentType: ApprovalActionLogDataTable_actionLogs$ref;
export type ApprovalActionLogDataTable_actionLogs = {|
  +actionLogs: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +actionDescription: string,
        +actionId: number,
        +actionTime: any,
        +actionType: ActionType,
        +user: ?{|
          +id: string,
          +fullName: ?string,
        |},
      |}
    |}>
  |},
  +$refType: ApprovalActionLogDataTable_actionLogs$ref,
|};
export type ApprovalActionLogDataTable_actionLogs$data = ApprovalActionLogDataTable_actionLogs;
export type ApprovalActionLogDataTable_actionLogs$key = {
  +$data?: ApprovalActionLogDataTable_actionLogs$data,
  +$fragmentRefs: ApprovalActionLogDataTable_actionLogs$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ApprovalActionLogDataTable_actionLogs",
  "type": "OrderApprovalNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actionLogs",
      "storageKey": null,
      "args": null,
      "concreteType": "ActionLogUserRequestNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ActionLogUserRequestNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ActionLogUserRequestNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "actionDescription",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "actionId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "actionTime",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "actionType",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "fullName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dfd9aca8543103ba7b55342c4ca67688';
module.exports = node;
